/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

function AnalyticsIcon({ color, size, customStyle = {} }) {
  return (
    <svg
        width={size}
        height={size}
        version="1.1"
        fill={colors[color] ? colors[color].main : colors.dark.main}
        fillRule="nonzero"
        style={customStyle}

        viewBox="0 -11 384 384"  xmlns="http://www.w3.org/2000/svg" id="fi_1548914"><path d="m10.667969 234.667969h42.664062c5.890625 0 10.667969 4.773437 10.667969 10.664062v106.667969c0 5.890625-4.777344 10.667969-10.667969 10.667969h-42.664062c-5.890625 0-10.667969-4.777344-10.667969-10.667969v-106.667969c0-5.890625 4.777344-10.664062 10.667969-10.664062zm0 0"></path><path d="m117.332031 149.332031h42.667969c5.890625 0 10.667969 4.777344 10.667969 10.667969v192c0 5.890625-4.777344 10.667969-10.667969 10.667969h-42.667969c-5.890625 0-10.664062-4.777344-10.664062-10.667969v-192c0-5.890625 4.773437-10.667969 10.664062-10.667969zm0 0"></path><path d="m224 192h42.667969c5.890625 0 10.664062 4.777344 10.664062 10.667969v149.332031c0 5.890625-4.773437 10.667969-10.664062 10.667969h-42.667969c-5.890625 0-10.667969-4.777344-10.667969-10.667969v-149.332031c0-5.890625 4.777344-10.667969 10.667969-10.667969zm0 0"></path><path d="m330.667969 128h42.664062c5.890625 0 10.667969 4.777344 10.667969 10.667969v213.332031c0 5.890625-4.777344 10.667969-10.667969 10.667969h-42.664062c-5.890625 0-10.667969-4.777344-10.667969-10.667969v-213.332031c0-5.890625 4.777344-10.667969 10.667969-10.667969zm0 0"></path><path d="m352 0c-17.664062.0195312-31.980469 14.335938-32 32 .042969 3.484375.660156 6.9375 1.828125 10.21875l-53.398437 31.742188c-7.007813-7.433594-17.167969-11.035157-27.292969-9.679688-10.128907 1.355469-18.980469 7.503906-23.789063 16.519531l-47.097656-23.328125c.230469-1.371094.367188-2.753906.417969-4.140625.023437-12.953125-7.761719-24.640625-19.722657-29.613281-11.960937-4.96875-25.738281-2.238281-34.898437 6.917969-9.164063 9.15625-11.902344 22.929687-6.9375 34.894531l-61.09375 45.59375c-4.84375-2.886719-10.375-4.425781-16.015625-4.457031-17.671875 0-32 14.324219-32 32 0 17.671875 14.328125 32 32 32s32-14.328125 32-32c-.027344-3.851563-.753906-7.660157-2.144531-11.25l61.703125-46.050781c12.070312 6.730468 27.125 4.757812 37.050781-4.859376l53.558594 26.527344c3.570312 15.902344 18.535156 26.574219 34.734375 24.769532 16.199218-1.804688 28.449218-15.503907 28.429687-31.804688 0-.8125-.179687-1.578125-.238281-2.375l58.078125-34.527344c5.035156 3.183594 10.867187 4.882813 16.828125 4.902344 17.671875 0 32-14.328125 32-32s-14.328125-32-32-32zm0 0"></path></svg>

  );
}

// Setting default values for the props of Office
AnalyticsIcon.defaultProps = {
  color: "dark",
  size: "16px",
  customStyle: {},
};

// Typechecking props for the Office
AnalyticsIcon.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customStyle: PropTypes.object,
};

export default AnalyticsIcon;
